// Read the currently selected UI language.
// Set by LanguageSwitcher (keyed 'abj_lang'). Defaults to 'en'.
export function currentLang() {
  try {
    return localStorage.getItem("abj_lang") || "en";
  } catch {
    return "en";
  }
}
